var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('ald-text',[_vm._v(_vm._s(_vm.$t('message.generic.error.notFound2')))]),_vm._v(" "),_c('Links')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }